export default function BrandHeader({ name, logo }) {
  return (
    <header
      style={{
        background: logo.bleedColor || '#fafafa',
        borderBottom: '1px solid var(--color-alt-tint-light)',
        minHeight: 340,
        display: 'flex',
        padding: 40,
      }}
    >
      <img
        src={logo.src}
        alt={`${name} logo`}
        style={{ marginInline: 'auto' }}
      />
    </header>
  )
}
